import { type ProviderResults } from '../../types';
import { isComplete } from '../providers/as-data-provider';

export const getHomeUrl = (
	availableProducts?: ProviderResults['availableProducts'],
): string | undefined => {
	if (availableProducts && isComplete(availableProducts) && availableProducts.data.startUrl) {
		if (availableProducts.data.startUrl.includes('.stg.')) {
			return 'https://home.stg.atlassian.com';
		}
		return 'https://home.atlassian.com';
	}

	return;
};
